import { deepMergeObjects } from './helper-functions';

type WidgetConfig = {
  colors?: Record<string, string>;
  content?: Record<string, any>;
  options?: Record<string, any>;
  customStyles?: any;
  active?: boolean;
  placements?: {
    active?: boolean;
    location?: string;
    position?: string;
    customTarget?: string;
    [key: string]: any;
  };
  [key: string]: any;
};

type BaseConfig = Record<string, WidgetConfig>;

type ExperimentOverrides = {
  visibility?: Record<string, boolean>;
  customization?: Record<string, Partial<WidgetConfig>>;
};

type ApplyOverrideResult = {
  data?: BaseConfig;
  error?: string;
};

function applyOverrides(
  baseConfig: BaseConfig,
  experimentOverrides: ExperimentOverrides
): BaseConfig {
  const { visibility, customization } = experimentOverrides;

  if (customization) {
    for (const widgetKey in customization) {
      if (!baseConfig[widgetKey]) continue;
      baseConfig[widgetKey] = deepMergeObjects(baseConfig[widgetKey], customization[widgetKey]);
    }
  }

  if (visibility) {
    for (const widgetKey in visibility) {
      if (!baseConfig[widgetKey]) continue;
      if (!baseConfig[widgetKey].placements) {
        baseConfig[widgetKey].placements = {};
      }
      baseConfig[widgetKey].placements.active = visibility[widgetKey];
    }
  }

  return baseConfig;
}

function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const Experiment = async (
  baseConfig: BaseConfig,
  maxRetries = 5,
  delayMs = 300
): Promise<ApplyOverrideResult> => {
  let retries = 0;

  while (retries < maxRetries) {
    const experiments = (window as any).Inspired?.experiments;

    if (experiments) {
      const updatedConfig = applyOverrides(baseConfig, experiments);
      return { data: updatedConfig };
    }

    await delay(delayMs);
    retries++;
  }

  return { error: 'Experiments data not found after max retries.' };
};
